<ng-container [ngSwitch]="type">
  <div
    class="checkbox-group-container position-relative"
    [class.has-errors]="(!formControl.pristine || isFormSubmitted) && formControl.errors"
  >
    <div class="checkbox-group-label">{{ configuration().label }}</div>
    <div class="checkbox-progress-bar" *ngIf="showPercentage">
      <div class="d-flex justify-content-sm-between">
        <span> {{ percentage | formatSeparator: user.configuration.decimalSeparator : 2 }} % </span>
        <span class="selected-info"> {{ selectedOptionCount }} / {{ options().length }} </span>
      </div>

      <mat-progress-bar mode="determinate" [value]="percentage"> </mat-progress-bar>
    </div>

    <ul *ngSwitchCase="'multiSelect'" class="checkbox-group-list">
      @for (option of isSelectedAddedOptions(); track option.id) {
        <li>
          <mat-checkbox
            [value]="option.id"
            [checked]="option.isSelected"
            (change)="toggleOption(option.id)"
            [disabled]="formControl.status === 'DISABLED'"
          >
            {{ option.name }}
          </mat-checkbox>
        </li>
      }
    </ul>

    <ul *ngSwitchCase="'singleSelect'">
      @for (option of isSelectedAddedOptions(); track option) {
        <li>
          <mat-radio-button
            [value]="option.id"
            [checked]="option.isSelected"
            (change)="updateSelectedRadio(option.id, radioButton)"
            (click)="updateSelectedRadio(option.id, radioButton)"
            [disabled]="formControl.status === 'DISABLED'"
            #radioButton
          >
            {{ option.name }}
          </mat-radio-button>
        </li>
      }
    </ul>
  </div>
  <app-custom-mat-error [control]="formControl" [isFormSubmitted]="isFormSubmitted"></app-custom-mat-error>
</ng-container>
